import React from 'react';
import { makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
	pageContainer: {
		textAlign: 'center',
		padding: tokens.spacingVerticalXXL,
	},
});

const Home = () => {
	const styles = useStyles();
	const page = (
		<div className={styles.pageContainer}>
			<h4>Welcome to Anark License Manager. This is an internal tool for generating new, or renewing, licenses for new or existing customers.</h4>
			<p>This page can be upgraded in the future to show cool stats and charts.</p>
		</div>
	)
	
	return page;
};

export { Home };